
define('text!views/secured/app.html',[],function () { return '<div id="app-container">\r\n    <header class="ui-layout-north">\r\n        <!-- ko compose: \'viewmodels/secured/header\', activate: true --><!-- /ko-->\r\n    </header>\r\n    <div id="content" class="container-fluid ui-layout-center">\r\n        <!-- ko router: { cacheViews : true } --><!-- /ko -->\r\n    </div>    \r\n</div>';});

